import { InjectionToken } from '@angular/core';
import { LocalStorageKey } from '../local-storage';

export const PREFIX_SETTINGS_LOCAL_STORAGE_KEY = new InjectionToken<LocalStorageKey>('prefixSettingsLocalStorageKey', {
  factory: () => LocalStorageKey.PREFIX_SETTINGS,
});
